/**
 * Socket Instance
 * Direct socket access for compatibility with old codebase
 * Based on Socket.js from ibitplay
 * EXACTLY LIKE OLDER WORKING CODE
 */

import io from 'socket.io-client';
import axios from 'axios';
import { SOCKET, DEVELOPMENT, storage, Event, Game, API } from './helper';

/**
 * Socket URL
 */
const ws = SOCKET;

let api = API + '/rate';

// Fetch rates only once - exactly like working code
axios({
  headers: {
    'Access-Control-Allow-Origin': '*',
    'Access-Control-Allow-Methods': '*',
    'content-type': '*',
    'Accept': 'application/json',
  },
  url: api,
  method: 'GET',
}).then(function (req) {
  var res = req.data;
  Object.keys(res).forEach(function (name, key) {
    let val = res[name];
    Game[name] = parseFloat(val);
  });
}).catch(function(error) {
  // Rate fetch error
});

/**
 * Initialize Socket Connection - EXACTLY LIKE OLDER WORKING CODE
 */
let socket;

export const connect = (token) => {
  socket = io.connect(ws, {
    secure: true,
    withCredentials: false,
    query: {
      auth_token: token,
      user_key: storage.getKey('key'),
    },
  });
};

if (!DEVELOPMENT) {
  if (storage.getKey('mthfk') === null) {
    connect(storage.getKey('token'));
  }
} else {
  connect(storage.getKey('token'));
}

let dis = false;

socket.on('connect', () => {
  Event.emit('connect');
  if (DEVELOPMENT) {
    if (dis) {
      console.clear();
    }
  }
});

/*
 * Disconnect Server
 */
socket.on('disconnect', () => {
  Event.emit('disconnect');
  dis = true;
});

/*
 * Disconnect Server for Hacker
 */
Event.on('mthfk', () => {
  if (!DEVELOPMENT) socket.disconnect();
});

// Export a function to get the socket instance (needed by other components)
export const getSocket = () => {
  return socket;
};

// Export a function to check if socket is connected (needed by other components)
export const isSocketConnected = () => {
  return socket?.connected || false;
};

// Export a function to disconnect socket (needed by other components)
export const disconnect = () => {
  if (socket) {
    socket.disconnect();
    socket = null;
  }
};

export default socket;
